import styled from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import CardActions from './CardActions';
import { Area, Compound } from '../../dtos';
import CardTags from '../../../../new-components/cards/CardTags';
import { useSelector } from 'react-redux';
import NewLocationIcon from '../../../../new-components/svg-icons/NewLocationIcon';
import { EntityTypes } from '../../../../new-lib/constants/common';

interface CardCoverProps {
  id: number;
  slug: string;
  index: number;
  recommended?: boolean;
  compound?: Compound;
  area?: any;
  coverImage: string;
  price: number;
  tags?: string[];
  entityType: EntityTypes;
}

const CardCover = ({
  id,
  slug,
  index,
  recommended,
  compound,
  area,
  coverImage,
  price,
  tags,
  entityType
}: CardCoverProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return (
    <Container>
      <CardTags tags={tags ?? []} />

      <div className="cover-image">
        <ImageWrapper
          width={303}
          height={190}
          src={coverImage}
          withSkeleton
          alt="Cover Image"
          objectFit="cover"
          style={{
            width: isMobile ? '100%' : '303px',
            minWidth: isMobile ? 'unset' : '303px',
            minHeight: '190px',
            height: 'auto',
            borderRadius: '10px'
          }}
        />
      </div>

      <CardActions
        id={id}
        slug={slug}
        index={index}
        compound={compound}
        entityType={entityType}
        area={area}
        recommended={recommended ?? false}
        price={price}
      />

      {isMobile && (
        <div className="area-chip">
          <h3 className="area">
            <span>
              <NewLocationIcon fill="#fff" circleFill="#828FA1" />
            </span>

            {area?.name}
          </h3>
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;

  .cover-image {
    width: 100%;
    height: 100%;
    position: relative;
  }

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    .cover-image {
      img {
        border-bottom-left-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
      }
    }
    .area-chip {
      display: flex;
      align-items: center;
      gap: 4px;
      position: absolute;
      bottom: 8%;
      inset-inline-start: 8px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 360px;
      padding: 4px 8px;
      width: fit-content;

      .area {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #eeeef0;
        font-size: 11px;
        font-family: materialRegular;

        span {
          display: flex;
        }
      }
    }
  }
`;

export default CardCover;
